import { ChallengeService } from '@duck/api-definitions'
import { useTar } from '@/modules'
import { ChallengeCard } from '../ChallengeCard'

/** The "Show me all that match" grid. Clicking a card surfaces it as the pick. */
export const HelpMePickMatches = ({
  challenges,
  onPick,
}: {
  challenges: ChallengeService.AvailableChallenge[]
  onPick: (c: ChallengeService.AvailableChallenge) => void
}) => {
  const { t } = useTar()
  return (
    <div className="w-full">
      <h2 className="mb-6 text-center text-xl font-semibold text-foreground">
        {t('challenges.helpMePick.matchesTitle')}
      </h2>
      <div className="grid grid-cols-1 justify-center gap-6 sm:[grid-template-columns:repeat(auto-fill,22rem)]">
        {challenges.map((c) => (
          <ChallengeCard key={c.taskSlug ?? c.taskId} challenge={c} onOpenDetail={onPick} />
        ))}
      </div>
    </div>
  )
}
